import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { ThemeService } from '../../core/services/theme.service';
import { UserContextService } from '../../core/services/user-context.service';
import { CompanyRole } from '../../core/enums/company-role.enum';
import { LayoutService } from '../../core/services/layout.service';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {
  authService = inject(AuthService);
  userContext = inject(UserContextService);
  themeService = inject(ThemeService);
  layoutService = inject(LayoutService);
  private router = inject(Router);

  CompanyRole = CompanyRole;

  toggleFullscreen() {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Erro ao ativar modo tela cheia: ${err.message}`);
      });
    } else {
      document.exitFullscreen().catch(err => {
        console.error(`Erro ao sair do modo tela cheia: ${err.message}`);
      });
    }
  }

  async onLogout() {
    await this.authService.logout();
    this.router.navigate(['/auth/login']);
  }

  onSelectCompany(companyId: string) {
    this.userContext.selectCompany(companyId);
  }
}
